const stateArray = {
	songs: [
		{
			id: 1,
			name: "Like A Rolling Stone",
			artist: "Bob Dylan",
			genre: "Rock",
			rating: 4,
		},
		{
			id: 2,
			name: "Yellow Submarine",
			artist: "Beatles",
			genre: "Rock",
			rating: 3,
		},
		{
			id: 3,
			name: "A Night In Tunisia",
			artist: " Dizzy Gillespie, Charlie Parker",
			genre: "Jazz",
			rating: 2,
		},
		{
			id: 4,
			name: "Watermelon Man",
			artist: "Herbie Hancock",
			genre: "Jazz",
			rating: 2,
		},
		{
			id: 5,
			name: "The thrill is gone",
			artist: " B.B. King",
			genre: "Blues",
			rating: 4,
		},
		{
			id: 6,
			name: "Modern Love",
			artist: "David Bowie",
			genre: "Blues",
			rating: 4,
		},
		{
			id: 7,
			name: "I Wanna Dance with Somebody",
			artist: "Whitney Houston",
			genre: "Pop",
			rating: 3,
		},
		{
			id: 8,
			name: "Free Fallin",
			artist: "Tom Petty",
			genre: "Country",
			rating: 4,
		},
		{
			id: 9,
			name: "Fight the Powe",
			artist: " Public Enemy",
			genre: "Chill-Out",
			rating: 3,
		},
		{
			id: 10,
			name: "When Doves Cry",
			artist: "Prince",
			genre: "Pop",
			rating: 4,
		},
		{
			id: 11,
			name: "Sexual Healing",
			artist: "Marvin Gaye",
			genre: "Blues",
			rating: 5,
		},
		{
			id: 12,
			name: "Dancing in the Dark",
			artist: "Bruce Springsteen",
			genre: "Blues",
			rating: 1,
		},
		{
			id: 13,
			name: "What’s Love Got to Do With It",
			artist: "Tina Turner",
			genre: "Pop",
			rating: 1,
		},
		{
			id: 14,
			name: "Everybody Wants to Rule the World",
			artist: "Tears for Fears",
			genre: "Country",
			rating: 4,
		},
		{
			id: 15,
			name: "Beat It",
			artist: " Michael Jackson",
			genre: "Jazz",
			rating: 2,
		},
		{
			id: 16,
			name: "More Than This",
			artist: "Roxy Music",
			genre: "Jazz",
			rating: 1,
		},
		{
			id: 17,
			name: "Once in a Lifetime",
			artist: "Talking Heads",
			genre: "Klassiek",
			rating: 3,
		},
		{
			id: 18,
			name: "Every Breath You Take",
			artist: "the Police",
			genre: "Club",
			rating: 4,
		},
		{
			id: 19,
			name: "Take On Me",
			artist: " A-ha",
			genre: "Pop",
			rating: 3,
		},
		{
			id: 20,
			name: "Just Like Honey",
			artist: "The Jesus and Mary Chain",
			genre: "Country",
			rating: 4,
		},
		{
			id: 21,
			name: "With or Without You",
			artist: "U2",
			genre: "Chill-Out",
			rating: 3,
		},
		{
			id: 22,
			name: "I Want to Know What Love Is",
			artist: "Sade",
			genre: "Regae",
			rating: 4,
		},
		{
			id: 23,
			name: "Stick Figure",
			artist: "Sound Of The Sea",
			genre: "Reggae",
			rating: 5,
		},
		{
			id: 24,
			name: "Barrington Levi",
			artist: "Black Roses",
			genre: "Reggae",
			rating: 5,
		},
	],
}

export default stateArray
